import { render, staticRenderFns } from "./detailNest.vue?vue&type=template&id=a5a79be4&scoped=true&"
import script from "./detailNest.vue?vue&type=script&lang=js&"
export * from "./detailNest.vue?vue&type=script&lang=js&"
import style0 from "./detailNest.vue?vue&type=style&index=0&id=a5a79be4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5a79be4",
  null
  
)

export default component.exports